import type { ComponentType } from 'react';
import { lazy } from 'react';

const BacktestConfigMock = lazy(() => import('./BacktestConfigMock'));
const BacktestProcessMock = lazy(() => import('./BacktestProcessMock'));
const CandleSimulationMock = lazy(() => import('./CandleSimulationMock'));
const PerformanceMetricsMock = lazy(() => import('./PerformanceMetricsMock'));
const ReadingNumbersMock = lazy(() => import('./ReadingNumbersMock'));
const ResearchWorkflowMock = lazy(() => import('./ResearchWorkflowMock'));
const OverfittedVsRealisticMock = lazy(() => import('./OverfittedVsRealisticMock'));
const WalkForwardMock = lazy(() => import('./WalkForwardMock'));
const WorkflowStepsMock = lazy(() => import('./WorkflowStepsMock'));
const LookAheadBiasMock = lazy(() => import('./LookAheadBiasMock'));
const ParameterHeatmapMock = lazy(() => import('./ParameterHeatmapMock'));
const RobustnessPipelineMock = lazy(() => import('./RobustnessPipelineMock'));
const StrategyBlueprintMock = lazy(() => import('./StrategyBlueprintMock'));
const ExitComparisonMock = lazy(() => import('./ExitComparisonMock'));
const DrawdownSurvivalMock = lazy(() => import('./DrawdownSurvivalMock'));
const PositionSizingImpactMock = lazy(() => import('./PositionSizingImpactMock'));
const StrategyCompletenessMock = lazy(() => import('./StrategyCompletenessMock'));
const RuleTestabilityMock = lazy(() => import('./RuleTestabilityMock'));
const EntryPatternsMock = lazy(() => import('./EntryPatternsMock'));
const StrategyLifecycleMock = lazy(() => import('./StrategyLifecycleMock'));
const StrategySelectorMock = lazy(() => import('./StrategySelectorMock'));
const BacktestSetupMock = lazy(() => import('./BacktestSetupMock'));
const ConfigDataRangeMock = lazy(() => import('./ConfigDataRangeMock'));
const ConfigPortfolioMock = lazy(() => import('./ConfigPortfolioMock'));
const ConfigAllocationMock = lazy(() => import('./ConfigAllocationMock'));
const ConfigSafetyMock = lazy(() => import('./ConfigSafetyMock'));
const BacktestRunningMock = lazy(() => import('./BacktestRunningMock'));
const BacktestResultsMock = lazy(() => import('./BacktestResultsMock'));
const ResultsDashboardOverviewMock = lazy(() => import('./ResultsDashboardOverviewMock'));
const MetricsCardMock = lazy(() => import('./MetricsCardMock'));
const BehaviourCardMock = lazy(() => import('./BehaviourCardMock'));
const TradeStructureCardMock = lazy(() => import('./TradeStructureCardMock'));
const ExposureCardMock = lazy(() => import('./ExposureCardMock'));
const RegimesCardMock = lazy(() => import('./RegimesCardMock'));
const DrawdownCardMock = lazy(() => import('./DrawdownCardMock'));
const DrawdownEnvelopeCardMock = lazy(() => import('./DrawdownEnvelopeCardMock'));
const ViabilityScoreCardMock = lazy(() => import('./ViabilityScoreCardMock'));
const PerformanceMetricsModalMock = lazy(() => import('./PerformanceMetricsModalMock'));
const BehaviourAnalysisMock = lazy(() => import('./BehaviourAnalysisMock'));
const TradeDistributionMock = lazy(() => import('./TradeDistributionMock'));
const ExposureTimelineMock = lazy(() => import('./ExposureTimelineMock'));
const RegimeCoverageMock = lazy(() => import('./RegimeCoverageMock'));
const DrawdownAnalysisMock = lazy(() => import('./DrawdownAnalysisMock'));
const DrawdownEnvelopeMock = lazy(() => import('./DrawdownEnvelopeMock'));
const GridSearchExplosionMock = lazy(() => import('./GridSearchExplosionMock'));
const OptimizationTargetsMock = lazy(() => import('./OptimizationTargetsMock'));
const WFAConfigMock = lazy(() => import('./WFAConfigMock'));
const WFASummaryMock = lazy(() => import('./WFASummaryMock'));
const WFAPeriodTableMock = lazy(() => import('./WFAPeriodTableMock'));
const OverfittingAnalysisMock = lazy(() => import('./OverfittingAnalysisMock'));
const AnchoredVsRollingMock = lazy(() => import('./AnchoredVsRollingMock'));
const CompositeEquityCurveMock = lazy(() => import('./CompositeEquityCurveMock'));
const RobustnessTiersMock = lazy(() => import('./RobustnessTiersMock'));
const MultiAssetWFAMock = lazy(() => import('./MultiAssetWFAMock'));
const ParameterStabilityWFAMock = lazy(() => import('./ParameterStabilityWFAMock'));
const TradeReorderMock = lazy(() => import('./TradeReorderMock'));
const EquityCurveFanMock = lazy(() => import('./EquityCurveFanMock'));
const ReturnDistributionMock = lazy(() => import('./ReturnDistributionMock'));
const DrawdownDistributionMock = lazy(() => import('./DrawdownDistributionMock'));
const MonteCarloStatsMock = lazy(() => import('./MonteCarloStatsMock'));
const ConfidenceLevelsMock = lazy(() => import('./ConfidenceLevelsMock'));
const PositionSizingMCMock = lazy(() => import('./PositionSizingMCMock'));
const StrategyComparisonMCMock = lazy(() => import('./StrategyComparisonMCMock'));
const MonteCarloConfigMock = lazy(() => import('./MonteCarloConfigMock'));
const PeakVsPlateauMock = lazy(() => import('./PeakVsPlateauMock'));
const SingleParamSensitivityMock = lazy(() => import('./SingleParamSensitivityMock'));
const ParameterHeatmapStabilityMock = lazy(() => import('./ParameterHeatmapStabilityMock'));
const ClusterStabilityMock = lazy(() => import('./ClusterStabilityMock'));
const ParameterDriftMock = lazy(() => import('./ParameterDriftMock'));
const StabilityResultsMock = lazy(() => import('./StabilityResultsMock'));

export const mockRegistry: Record<string, ComponentType> = {
  backtestConfig: BacktestConfigMock,
  backtestProcess: BacktestProcessMock,
  candleSimulation: CandleSimulationMock,
  performanceMetrics: PerformanceMetricsMock,
  readingNumbers: ReadingNumbersMock,
  researchWorkflow: ResearchWorkflowMock,
  overfittedVsRealistic: OverfittedVsRealisticMock,
  walkForward: WalkForwardMock,
  workflowSteps: WorkflowStepsMock,
  lookAheadBias: LookAheadBiasMock,
  parameterHeatmap: ParameterHeatmapMock,
  robustnessPipeline: RobustnessPipelineMock,
  strategyBlueprint: StrategyBlueprintMock,
  exitComparison: ExitComparisonMock,
  drawdownSurvival: DrawdownSurvivalMock,
  positionSizingImpact: PositionSizingImpactMock,
  strategyCompleteness: StrategyCompletenessMock,
  ruleTestability: RuleTestabilityMock,
  entryPatterns: EntryPatternsMock,
  strategyLifecycle: StrategyLifecycleMock,
  strategySelector: StrategySelectorMock,
  backtestSetup: BacktestSetupMock,
  configDataRange: ConfigDataRangeMock,
  configPortfolio: ConfigPortfolioMock,
  configAllocation: ConfigAllocationMock,
  configSafety: ConfigSafetyMock,
  backtestRunning: BacktestRunningMock,
  backtestResults: BacktestResultsMock,
  resultsDashboardOverview: ResultsDashboardOverviewMock,
  metricsCard: MetricsCardMock,
  behaviourCard: BehaviourCardMock,
  behaviourAnalysis: BehaviourAnalysisMock,
  tradeStructureCard: TradeStructureCardMock,
  tradeDistribution: TradeDistributionMock,
  exposureCard: ExposureCardMock,
  exposureTimeline: ExposureTimelineMock,
  regimesCard: RegimesCardMock,
  regimeCoverage: RegimeCoverageMock,
  drawdownCard: DrawdownCardMock,
  drawdownAnalysis: DrawdownAnalysisMock,
  drawdownEnvelope: DrawdownEnvelopeMock,
  drawdownEnvelopeCard: DrawdownEnvelopeCardMock,
  viabilityScoreCard: ViabilityScoreCardMock,
  performanceMetricsModal: PerformanceMetricsModalMock,
  gridSearchExplosion: GridSearchExplosionMock,
  optimizationTargets: OptimizationTargetsMock,
  wfaConfig: WFAConfigMock,
  wfaSummary: WFASummaryMock,
  wfaPeriodTable: WFAPeriodTableMock,
  overfittingAnalysis: OverfittingAnalysisMock,
  anchoredVsRolling: AnchoredVsRollingMock,
  compositeEquityCurve: CompositeEquityCurveMock,
  robustnessTiers: RobustnessTiersMock,
  multiAssetWFA: MultiAssetWFAMock,
  parameterStabilityWFA: ParameterStabilityWFAMock,
  tradeReorder: TradeReorderMock,
  equityCurveFan: EquityCurveFanMock,
  returnDistribution: ReturnDistributionMock,
  drawdownDistribution: DrawdownDistributionMock,
  monteCarloStats: MonteCarloStatsMock,
  confidenceLevels: ConfidenceLevelsMock,
  positionSizingMC: PositionSizingMCMock,
  strategyComparisonMC: StrategyComparisonMCMock,
  monteCarloConfig: MonteCarloConfigMock,
  peakVsPlateau: PeakVsPlateauMock,
  singleParamSensitivity: SingleParamSensitivityMock,
  parameterHeatmapStability: ParameterHeatmapStabilityMock,
  clusterStability: ClusterStabilityMock,
  parameterDrift: ParameterDriftMock,
  stabilityResults: StabilityResultsMock,
};
